export default class HotReward {
    static async fetchHotReward() {
            const response = await fetch('/wp-json/electro/v1/options/hot-reward', { credentials: 'same-origin' });
            const json = await response.json();
            if (json.status === 0) {
                return json.data;
            }
            return false;
    }
}
